"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARE_MODES = void 0;
var SHARE_MODES;
(function (SHARE_MODES) {
    SHARE_MODES["CHANNEL"] = "channel";
    SHARE_MODES["VIDEO"] = "video";
})(SHARE_MODES = exports.SHARE_MODES || (exports.SHARE_MODES = {}));
//# sourceMappingURL=constants.js.map